module.exports = __webpack_public_path__ + "4de72824ed7f26814426dd72e17a4da7.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/bryan-hughes.jpg
// module id = 506
// module chunks = 0